import React, { useRef } from 'react';
import { Icons, SVG } from '../../../../components/atoms/SVG';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Tooltip, TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { GlobalDocumentIds } from '../../../../types/GlobalDocumentIds';
import { FetchSubPanel } from '../../MainNavigationTypes';

type NextPanelButtonType = {
  panelName: string;
  url: string;
  fetchUrl: string;
  fetchSubPanel: FetchSubPanel;
  panelLevel: number;
  activeOpenButtonId?: string;
  setActiveOpenButtonId?: (activeOpenButtonId: string | undefined) => void;
};

/**
 * To open next panel and fetch data of it.
 */
export function NextPanelButton({
  panelName,
  url,
  fetchUrl,
  fetchSubPanel,
  panelLevel,
  activeOpenButtonId,
  setActiveOpenButtonId,
}: NextPanelButtonType) {
  const { t } = useSonTranslation('MainNavigation');
  const buttonRef = useRef<HTMLButtonElement>(null);
  const buttonName = t('subPanels.nextPanelButton', { panelName });
  const id = fetchUrl;

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (setActiveOpenButtonId) {
      setActiveOpenButtonId(id);
    }
    fetchSubPanel(fetchUrl, panelLevel, panelName, url, buttonRef);
  };

  return (
    <Tooltip attachTo={buttonRef} hideTooltipFromScreenReader placement={TooltipPlacement.RIGHT} hideOnClick>
      <button
        id={id}
        ref={buttonRef}
        title={buttonName}
        className="main-navigation__sub-panel-button"
        onClick={handleClick}
        type="button"
        aria-controls={
          id === activeOpenButtonId ? `${GlobalDocumentIds.mainNavigationSubPanel}${panelLevel}` : undefined
        }
        aria-haspopup="true"
        aria-expanded={id === activeOpenButtonId}
      >
        <span className="invisible">{buttonName}</span>
        <span className="main-navigation__sub-panel-button-icon">
          <SVG svgSpriteId={Icons.ARROW_RIGHT} />
        </span>
      </button>
    </Tooltip>
  );
}
